import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import StoryList from "../components/stories/StoryList";
import StoryReader from "../components/stories/StoryReader";
import PageMeta from "../components/seo/PageMeta";
import { getStoryById, STORIES } from "../data/stories";
import {
  buildStorySeoMeta,
  isCanonicalStoryPath,
  storyHref,
} from "../lib/storySeo";
import { buildWebPageJsonLd } from "../lib/seo";
import "../styles/stories.css";

export default function StoriesPage() {
  const { storyId, storySlug: routeStorySlug } = useParams();
  const navigate = useNavigate();
  const story = storyId ? getStoryById(storyId) : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [storyId, routeStorySlug]);

  useEffect(() => {
    if (storyId && !story) {
      navigate("/stories", { replace: true });
    }
  }, [storyId, story, navigate]);

  useEffect(() => {
    if (!story) {
      return;
    }

    const canonicalPath = storyHref(story);
    if (!routeStorySlug || !isCanonicalStoryPath(story, routeStorySlug)) {
      navigate(canonicalPath, { replace: true });
    }
  }, [navigate, routeStorySlug, story]);

  const openStory = (id) => {
    const target = getStoryById(id);
    navigate(target ? storyHref(target) : `/stories/${id}`);
  };

  const backToList = () => {
    navigate("/stories");
  };

  if (story) {
    const seo = buildStorySeoMeta(story);

    return (
      <>
        <PageMeta
          title={seo.pageTitle}
          description={seo.description}
          path={seo.path}
          image={seo.image}
          imageAlt={seo.imageAlt}
          type="article"
          section={seo.section}
          keywords={seo.keywords}
          publishedTime={seo.publishedTime}
          modifiedTime={seo.publishedTime}
          jsonLd={seo.jsonLd}
        />
        <StoryReader story={story} onBack={backToList} onOpen={openStory} />
      </>
    );
  }

  return (
    <>
      <PageMeta
        title="Stories"
        description="Long-form photo stories from CJ Jayamaha — wildlife conservation, adventure travel, and the journeys that stay with you."
        path="/stories"
        image={STORIES[0]?.img || "rhino-hero.jpg"}
        keywords={["photo stories", "travel writing", "wildlife", "conservation", "Kenya"]}
        jsonLd={buildWebPageJsonLd({
          title: "Stories",
          description:
            "Long-form photo stories from CJ Jayamaha on wildlife, travel, and conservation.",
          path: "/stories",
          image: STORIES[0]?.img || "rhino-hero.jpg",
        })}
      />
      <StoryList onOpen={openStory} />
    </>
  );
}
